/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Thumbnail_Locked_TitleInputs */

const en_explorer_thumbnail_locked_title = /** @type {(inputs: Explorer_Thumbnail_Locked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locked Project`)
};

const fr_explorer_thumbnail_locked_title = /** @type {(inputs: Explorer_Thumbnail_Locked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projet verrouille`)
};

const de_explorer_thumbnail_locked_title = /** @type {(inputs: Explorer_Thumbnail_Locked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesperrtes Projekt`)
};

const it_explorer_thumbnail_locked_title = /** @type {(inputs: Explorer_Thumbnail_Locked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progetto bloccato`)
};

const ru_explorer_thumbnail_locked_title = /** @type {(inputs: Explorer_Thumbnail_Locked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проект заблокирован`)
};

const es_explorer_thumbnail_locked_title = /** @type {(inputs: Explorer_Thumbnail_Locked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proyecto bloqueado`)
};

const zh_cn2_explorer_thumbnail_locked_title = /** @type {(inputs: Explorer_Thumbnail_Locked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已锁定项目`)
};

const ja_explorer_thumbnail_locked_title = /** @type {(inputs: Explorer_Thumbnail_Locked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロックされたプロジェクト`)
};

const hi_explorer_thumbnail_locked_title = /** @type {(inputs: Explorer_Thumbnail_Locked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लॉक किया गया प्रोजेक्ट`)
};

const pt_pt2_explorer_thumbnail_locked_title = /** @type {(inputs: Explorer_Thumbnail_Locked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projeto bloqueado`)
};

/**
* | output |
* | --- |
* | "Locked Project" |
*
* @param {Explorer_Thumbnail_Locked_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_thumbnail_locked_title = /** @type {((inputs?: Explorer_Thumbnail_Locked_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Thumbnail_Locked_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_thumbnail_locked_title(inputs)
	if (locale === "de") return de_explorer_thumbnail_locked_title(inputs)
	if (locale === "it") return it_explorer_thumbnail_locked_title(inputs)
	if (locale === "ru") return ru_explorer_thumbnail_locked_title(inputs)
	if (locale === "es") return es_explorer_thumbnail_locked_title(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_thumbnail_locked_title(inputs)
	if (locale === "ja") return ja_explorer_thumbnail_locked_title(inputs)
	if (locale === "hi") return hi_explorer_thumbnail_locked_title(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_thumbnail_locked_title(inputs)
	return en_explorer_thumbnail_locked_title(inputs)
});